export default function Footer() {
  return (
    <footer className="border-t border-[rgba(30,36,48,0.08)] py-12 md:py-20">
      <div className="max-w-[1120px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-10 md:mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/cd71ffc29b4128737d19646fb970e806/23c6485507286e2714b90e8bd3ae7df8.png"
              alt="Valaxis Group"
              className="block mb-4 h-[80px] md:h-[110px] w-auto object-contain"
            />
            <p className="text-[15px] text-[#5B6475] max-w-[400px]">
              Operator-led healthcare and technology platform focused on disciplined execution and long-term value creation.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {[
              { label: 'About Valaxis Group', id: 'about-valaxis' },
              { label: 'Investment Thesis', id: 'investment-focus' },
              { label: 'Values', id: 'values' },
              { label: 'For Business Owners', id: 'for-business-owners' },
              { label: 'For Investors', id: 'for-investors' },
              { label: 'Contact', id: 'contact' },
            ].map((link) => (
              <button
                key={link.id}
                onClick={() => {
                  const element = document.getElementById(link.id);
                  if (element) {
                    const offset = 84;
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - offset;
                    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                  }
                }}
                className="text-[15px] text-[#5B6475] hover:text-[#1E2430] transition-colors cursor-pointer text-left whitespace-nowrap"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>

        <div className="pt-6 md:pt-8 border-t border-[rgba(30,36,48,0.08)] flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-[14px] text-[#5B6475]">
            © 2026 Valaxis Group. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[14px] text-[#5B6475] hover:text-[#1E2430] transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}